import { Box } from '@mui/material';

import TopHeader from './topheader/Topheader';

import Navbar from './Navbar/Navbar';

function Header() {

  return (
    <Box sx={{ position: 'sticky', top: 0, zIndex: 1100 }}>
      <TopHeader />
      <Navbar />
    </Box>
  );
}

export default Header;
